type TierBadgeProps = {
  name: string;
  color: string;
  className?: string;
  style?: React.CSSProperties;
};

type GenericBadgeProps = {
  name: string;
  color: string;
  className?: string;
  style?: React.CSSProperties;
  showDot?: boolean;
};

const GenericBadge = ({ name, color, className, style }: GenericBadgeProps) => {
  const badgeStyle = {
    color,
    border: `1px solid ${color}`,
    borderRadius: '16px',
    backgroundColor: `${color}33`,
    fontSize: '12px',
    lineHeight: '14px',
    fontWeight: 'bold',
    display: 'inline-flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '5px 8px',
    ...style,
  };

  return (
    <span className={className} style={badgeStyle}>
      {name}
    </span>
  );
};

const TierBadge = ({ name, color, className, style }: TierBadgeProps) => {
  return (
    <GenericBadge
      name={name}
      color={color}
      className={className}
      style={style}
    />
  );
};

export default TierBadge;
export { GenericBadge };
